<template>
  <div>
    <div id="home2">
      <img style="width: 20vw;margin:20px 0;" src="../assets/imgs/success.png" />
      <h1>퇴직금 찾기 신청이<br/>성공적으로 완료되었습니다</h1>
      <p style="color: #717B85;margin-top: 10px;">담당 노무법인에서 검토 후, 진행 상황을<br/>카카오톡 알림톡으로 보내드립니다</p>
      <div class="bottomArea">
        공유하기
        <div class="menus">
          <div @click="share_send">
            <img src="../assets/imgs/kakao_share.png"/>
            <span>카카오톡</span>
          </div>
          <div @click="copy_link">
            <img src="../assets/imgs/copy_link.png"/>
            <span>링크복사</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  import { postAction } from '@/network/manage';



  export default {
    name: 'Result',
    components: {

    },
    data() {
      return {

      }
    },
    created(){
      Kakao.init('f1d4d986339283ecbcd6b521054e5012');
      Kakao.isInitialized();
    },
    methods:{
      async copy_link() {
        try {
          await navigator.clipboard.writeText("https://pay.uyhr.co.kr/");
          this.$message({message: 'Copy success!',type: 'success',center: true});
        } catch (err) {

        }
      },
      share_send() {
        Kakao.Share.sendDefault({
          objectType: 'text',
          text: '혹시 예전에 일했던 회사 퇴직금 안 찾아간 거 있을 수도 있대.여기서 한 번에 조회 가능하니까 시간 날 때 확인해봐 👍',
          link: {
            mobileWebUrl: 'https://pay.uyhr.co.kr',
            webUrl: 'https://pay.uyhr.co.kr',
          },
        });
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home2{height:calc(100vh - 92px);display: flex;flex-direction: column;width: 100%;padding:20px;justify-content: center;align-items: center;text-align: center;}
  h1{color:#333333;font-size: 24px;}
  .btn{background:#4873FF;color:#ffffff;display: flex;position: fixed;bottom:20px;justify-content: center;margin-top:30px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .btn img{width: 16px;margin-right: 10px;}
  .border{border:1px solid #DDDDDD;padding:20px;border-radius: 20px;margin-top: 20px;display: grid;grid-template-columns: 1fr; gap: 10px;}
  .border div{display: flex;align-items: center;justify-content: space-between;color: #717B85;}
  .border b{color:#333333;}
  .bottomArea{display: flex;flex-direction: column;align-items: center;margin-top: 20vh;}
  .bottomArea .menus{display: flex;align-items: center;margin-top: 6vh;}
  .bottomArea .menus div{display: grid;grid-template-columns: 1fr;gap: 10px;place-items: center;}
  .bottomArea .menus div:nth-child(2){margin-left: 80px;}
  .bottomArea .menus div img{width: 50px;}
</style>
